import { formatCount, formatRate } from '../../../lib/outreach/stats'

/** "12 (16.7%)" for a count with its rate. */
export function countWithRate(count: number, rate: number | null): string {
  return `${formatCount(count)} (${formatRate(rate)})`
}

export function rangeLabel(days: number): string {
  return `last ${days} days`
}
